import React, { useEffect } from 'react';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (!duration) return;

    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColor = type === 'success' ? 'bg-green-500' : type === 'error' ? 'bg-red-500' : 'bg-blue-500';
  const icon = type === 'success' ? <FaCheckCircle size={24} /> : <FaExclamationCircle size={24} />;

  return (
    <div className={`fixed top-24 right-4 z-[9999] ${bgColor} text-white px-6 py-4 rounded-lg shadow-2xl flex items-center space-x-3 animate-slide-in-right max-w-md`}>
      <div className="flex-shrink-0">{icon}</div>
      <p className="flex-1 font-medium">{message}</p>

    </div>
  );
};

export default Toast;